import React from "react";

/**
 * Money input with a fixed "$" prefix on the left so the value
 * doesn't overlap the placeholder/typed digits.
 */
export function DollarInput({
  testId,
  value,
  onChange,
  placeholder = "0.00",
  step = "0.01",
  min = "0",
  disabled = false,
  className = "",
}) {
  return (
    <div className={`relative ${className}`}>
      <span
        className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none font-semibold"
        aria-hidden="true"
      >
        $
      </span>
      <input
        type="number"
        step={step}
        min={min}
        data-testid={testId}
        className="cm-input"
        style={{ paddingLeft: "28px" }}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
}

export default DollarInput;
